import { render, staticRenderFns } from "./UiBtn.vue?vue&type=template&id=f94c5d80&"
import script from "./UiBtn.vue?vue&type=script&lang=js&"
export * from "./UiBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/server/itg-custom/production/front/components/UiIcon.vue').default})
